import { IVotingSettings } from '@/shared/models';

import _ from 'lodash';
import { Component, Prop, Provide, Vue } from 'vue-property-decorator';
import { IElection } from '@/shared/models/election';

import VoteComponent from '../vote-component/vote-component.vue';
import { RedirectHelper } from '@/shared/api-client/helpers/redirect-helper';
import { ArgumentValidator } from '@/shared/helpers';
import { VoteEnvironmentStore } from '../../services/vote-environment-store';

@Component({
    components: {
        VoteComponent
    }
})
export default class StandaloneElectionVoteComponent extends Vue {

    @Provide() voteEnvironment = new VoteEnvironmentStore();

    @Prop() public election!: IElection;
    @Prop() public votingSettings!: IVotingSettings;
    @Prop({ default: true }) public showProfilePictures!: boolean;
    @Prop() public translations!: { [key: string]: string; };

    public handleVoteStored(electionId: string): void {

        ArgumentValidator.notNullOrEmpty(electionId, `electionId`);

        RedirectHelper.redirectTo(`/vote/voteplaced/${encodeURI(electionId)}`);
    }
}
